import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import { GetSingleWorkout } from "../../../../APIs/Function/Workout/WorkoutPlans/GetSingleWorkout";
import CustomButton from "../../../../Components/Button/CustomButton";

const SingleWorkoutPlans = () => {
  const [singleWorkout, setSingleWorkout] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const handleSingleWorkout = async () => {
    try {
      setLoading(true);
      let res = await GetSingleWorkout(id);
      setSingleWorkout(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleWorkout();
  }, []);
  console.log(singleWorkout);
  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          {/* Heading  */}
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/workoutplans"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Details
              </Typography>
            </Box>
            <Box>
            <Link to={`/EditWorkoutplans/${singleWorkout.id}`}>
                <CustomButton
                  sx={{
                    width: { xs: "40px", md: "50px", lg: "80px" },
                    height: { xs: "10px", md: "50px", lg: "50px " },
                  }}
                >
                  Edit
                </CustomButton>
              </Link>
            </Box>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                m: "auto",
                p: 2,
                height: "80vh",
                width:"50%",
                
              }}
            >
              <Box
                sx={{
                  textAlign: "center",
                  height: "65%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  boxSizing: "border-box",
                  border: "1px solid #E8E8E8",
                  borderRadius: "5px",
                  p: "15px",
                  width:"100%"
                }}
              >
                <Typography
                  sx={{
                    textAlign: "left",
                    width: "100%",
                    fontFamily: "Inter",
                    fontSize: "20px",
                  }}
                >
                  Banner Image
                </Typography>
                <Box
                  sx={{
                    m: "auto",
                    mt: "10px",
                    height: "90%",
                    width:"100%",
                    display: "flex",
                    justifyContent: "center",
                    overflow:"hidden"
                  }}
                >
                  <img
                    width={"100%"}
                    height={"100%"}
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                    src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${singleWorkout.banner_img}`}
                    alt=""
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  border: "1px solid #E8E8E8",
                  borderRadius: "5px",
                  p: "15px",
                  alignItems: "center",
                  height: "30%",
                  textAlign: "left",
                  width: "60%",
                  mt: "20px",
                  
                }}
              >
                <Typography
                  sx={{
                    textAlign: "left",
                    width: "100%",
                    fontFamily: "Inter",
                    fontSize: "20px",
                  }}
                >
                  Video
                </Typography>
                <Box
                  sx={{
                    mt: 1,
                    height: "80%",
                    width: "100%",
                    justifyContent: "start",
                    
                  }}
                >
                  {singleWorkout?.video ? (
                    <video
                      width={"100%"}
                      height={"100%"}
                      controls
                      autoPlay
                      loop
                      muted
                    >
                      <source
                        src={`https://api-qhealth.equitysofttechnologies.com/upload/video/${singleWorkout.video}`}
                        type="video/mp4"
                      />
                    </video>
                  ) : (
                    <Typography>No video available</Typography>
                  )}
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "50%",
                boxSizing: "border-box",
                gap: "10px",
                p: 2,
                
              }}
            >
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #E8E8E8",
                  textAlign: "left",
                  borderRadius: "5px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "14px",
                    color: "#737373",
                  }}
                >
                  {" "}
                  Title
                </Typography>
                <Typography sx={{ fontFamily: "Inter" }}>
                  {" "}
                  {singleWorkout.title}
                </Typography>
              </Box>
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #E8E8E8",
                  textAlign: "left",
                  borderRadius: "5px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "14px",
                    color: "#737373",
                  }}
                >
                  Description :
                </Typography>
                <Typography sx={{ fontFamily: "Inter" }}>
                  {singleWorkout.description}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

  
    </>
  );
};

export default SingleWorkoutPlans;


